import { remove as removeDiacritics } from 'diacritics';
import { compose } from '../functional/compose';
import { toLowerCase } from './to-lower-case';
/**
 * @name toLowerCaseWithoutDiacritics
 * @description This function transforms the string in lower case and remove diatrics
 * @param {string} stringValue The string to transform.
 * @returns {string} The string formatted
 *
 * @example
 * import {toLowerCaseWithoutDiacritics} from 'gso-utilities';
 * const myString = 'élEpHant';
 *  const transformed = toLowerCaseWithoutDiacritics(myString);
 * console.log(transformed); // elephant
 *
 */
const toLowerCaseWithoutDiacritics = compose(removeDiacritics, toLowerCase);
export { toLowerCaseWithoutDiacritics };
//# sourceMappingURL=to-lower-case-without-diacritics.js.map